export const stateLogin = {
    session: null,
    token: null,
    token_drissly: null,
    role: null,
    user: null,
}